import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';
export default function (feature) {
    return (getUserConfiguration().SessionSettings.IsSubstrateSearchServiceAvailable &&
        isFeatureEnabled(feature));
}
//# sourceMappingURL=is3SFeatureEnabled.js.map